import React from 'react';

import { PageTitle } from '../../../components';
import { RequestEstimate } from '../../../sections';



const RequestPage = () => {

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Request Estimate'} page={'Request Estimate'} />

      {/* Request Estimate Section */}
      <RequestEstimate />

    </>

  );

}

export default RequestPage;